import { render, staticRenderFns } from "./PulsingChip.vue?vue&type=template&id=08d55571&scoped=true&"
var script = {}
import style0 from "./PulsingChip.vue?vue&type=style&index=0&id=08d55571&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d55571",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
